// extracted by mini-css-extract-plugin
export default {"fixBottom":"index_fixBottom_VptQM","activityImage":"index_activityImage_YNCUQ"};